export default __webpack_public_path__ + "static/media/login.70e2a504.mp3";